import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Sparkles } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 overflow-hidden px-6 bg-gradient-to-br from-brand-bg via-brand-bgDeep to-brand-card" data-id="element-13">
      {/* Dotted pattern overlay */}
      <div className="absolute inset-0 bg-dots-pattern bg-dots-sm opacity-60 pointer-events-none" data-id="element-14"></div>
      {/* Decorative orange blur */}
      <div className="absolute top-20 -left-20 w-72 h-72 bg-brand-accent/20 rounded-full blur-3xl pointer-events-none" data-id="element-15"></div>
      <div className="absolute bottom-10 -right-20 w-96 h-96 bg-brand-accentLight/20 rounded-full blur-3xl pointer-events-none" data-id="element-16"></div>

      <div className="relative max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="max-w-2xl" data-id="element-18">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-navy text-white text-sm font-bold tracking-wide mb-6 shadow-md" data-id="element-19">
            <Sparkles className="w-4 h-4 text-brand-accent" data-id="element-20" />
            <span data-id="element-21">CASHBOOK · GUÍA DIGITAL</span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black leading-[1.05] text-brand-navy mb-6 uppercase" data-id="element-22">
            Crea y vende{' '}
            <span className="text-brand-accent" data-id="element-23">
              tu primer producto digital
            </span>{' '}
            desde cero
          </h1>

          <p className="text-lg md:text-xl text-brand-textSoft leading-relaxed mb-8 font-medium" data-id="element-24">
            Aprende paso a paso cómo transformar una idea, conocimiento o
            experiencia en un producto digital que puedas vender utilizando
            Instagram y TikTok.
          </p>

          <motion.a href="https://shop.beacons.ai/byesthermaria/Ebooks" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-flex items-center justify-center gap-3 bg-brand-accent hover:bg-brand-accentHover text-white px-8 py-4 rounded-2xl font-bold text-lg transition-colors shadow-xl shadow-brand-accent/30 w-full sm:w-auto" data-id="element-25">
            QUIERO EMPEZAR AHORA
            <ArrowRight className="w-5 h-5" data-id="element-26" />
          </motion.a>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative lg:h-[500px] flex justify-center items-center" data-id="element-27">
          {/* CashBook product mockup image */}
          <div className="relative w-full max-w-lg" data-id="element-28">
            <div className="absolute -inset-4 bg-brand-card rounded-3xl transform rotate-2 border border-brand-cardDark/50" data-id="element-29"></div>
            <div className="relative bg-white rounded-3xl shadow-xl border border-brand-cardDark overflow-hidden" data-id="element-30">
              <img src="https://cdn.magicpatterns.com/uploads/kzBiVBzT7jTZjzT3JgscP1/IMG_6297.jpg" alt="CashBook — Crea y vende tu primer producto digital + estrategia TikTok Live, incluye 5 bonos exclusivos y derechos de reventa MRR" className="w-full h-auto block" data-id="element-31" />
            </div>

            {/* Floating sale notification */}
            <motion.div animate={{
            y: [0, -10, 0]
          }} transition={{
            repeat: Infinity,
            duration: 4,
            ease: 'easeInOut'
          }} className="absolute -right-4 -top-4 md:-right-6 md:-top-6 bg-white p-4 rounded-2xl shadow-lg border border-brand-cardDark flex items-center gap-3 z-10" data-id="element-32">
              <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center text-green-600 font-bold" data-id="element-33">
                $
              </div>
              <div data-id="element-34">
                <div className="text-xs text-brand-text/60 font-medium" data-id="element-35">
                  Nueva Venta
                </div>
                <div className="text-sm font-bold text-brand-text" data-id="element-36">$19.00</div>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}